<template>
  <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
    <!-- Replace with your content -->
    <slot></slot>
    <!-- /End replace -->
  </div>
</template>
